import type { VenueTypeCode } from '../features/landing/constants/venueTypes';
import { VenueType } from '../features/landing/constants/venueTypes';

interface VenueTypeColorScheme {
  primary: string;
  light: string;
  dark: string;
  bg: string;
  gradient: string;
  glow: string;
}

export const venueTypeColors: Record<VenueTypeCode, VenueTypeColorScheme> = {
  [VenueType.GAMING]: {
    primary: '#6C5CE7', // Brand purple
    light: '#8B7FEE',
    dark: '#5649C4',
    bg: 'rgba(108, 92, 231, 0.1)',
    gradient: 'linear-gradient(135deg, #6C5CE7 0%, #5649C4 100%)',
    glow: '0 0 40px rgba(108, 92, 231, 0.3)',
  },
  [VenueType.SNOOKER]: {
    primary: '#00B000', // Brand green
    light: '#33C633',
    dark: '#008000',
    bg: 'rgba(0, 176, 0, 0.1)',
    gradient: 'linear-gradient(135deg, #00B000 0%, #008000 100%)',
    glow: '0 0 40px rgba(0, 176, 0, 0.3)',
  },
  [VenueType.KIDS_PLAYAREA]: {
    primary: '#FF8800', // Brand orange
    light: '#FFA533',
    dark: '#CC6D00',
    bg: 'rgba(255, 136, 0, 0.1)',
    gradient: 'linear-gradient(135deg, #FF8800 0%, #CC6D00 100%)',
    glow: '0 0 40px rgba(255, 136, 0, 0.3)',
  },
};

export function getVenueTypeColor(venueType: VenueTypeCode): VenueTypeColorScheme {
  return venueTypeColors[venueType as VenueTypeCode] || venueTypeColors[VenueType.GAMING];
}
